'use client';

export interface IRadioButton {
  id?: string;
  name?: string;
  value: string;
  label: string;
  disabled?: boolean;
  checked?: boolean;
  onChange: (...event: unknown[]) => void;
  defaultChecked?: boolean;
  dataTestId?: string;
  classNames?: { [x: string]: string };
}

export const RadioButton = ({
  id,
  name,
  value,
  label,
  disabled,
  onChange,
  defaultChecked,
  checked,
  dataTestId,
  classNames,
  ...props
}: IRadioButton) => {
  const disabledClassText = disabled ? 'opacity-50 cursor-not-allowed' : '';
  return (
    <label className="flex items-center gap-3" htmlFor={id}>
      <input
        type="radio"
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        disabled={disabled}
        className={`${
          classNames?.input || ''
        } before:content[''] border-gray-200 relative size-5 cursor-pointer appearance-none rounded-full border transition-all before:absolute before:left-2/4 before:top-2/4 before:block before:size-4 before:-translate-x-2/4 before:-translate-y-2/4 before:rounded-full 
      before:border before:border-white checked:border checked:border-white checked:bg-primary`}
        checked={checked}
        defaultChecked={defaultChecked}
        data-testid={dataTestId}
        {...props}
      />
      <span className={`${disabledClassText} mb-0 cursor-pointer ${classNames?.labelText || ''}`}>{label}</span>
    </label>
  );
};

RadioButton.displayName = 'RadioButton';
